import { paymentResultBankType, paymentResultPay3000Type, paymentResultType, withdrawConfigItemType, withdrawConfigType } from '@sharedTemplates/deposit/Deposit.module';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from '@services/api.service';
import { UserHelper } from '@helpers/user.helper';
import { UiHelper } from '@helpers/ui.helper';
import { TranslateService } from '@services/translate.service';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable()
export class WithdrawService {
  public amount: any = '';
  public selectedWithdrawItem = {
    MaxValue: null,
    MinValue: null,
    Description: '',
    DepositTypeId: null,
    paymentMethodId: '',
    result: {
      finished: false,
      success: false,
      message: '',
    },
  };
  selectedWallet: {
    BranchType: number;
    Balance: number;
    BrancName: string;
    paymentMethodId: string;
  };

  public withdrawPaymentList = [];

  private ismobile: boolean;
  constructor(public dialog: MatDialog, public _ApiService: ApiService, public _UserHelper: UserHelper, public _UiHelper: UiHelper, public _TranslateService: TranslateService) {
    this.ismobile = this._UiHelper.windowsWidth < 990;
  }

  public withdrawConfig: withdrawConfigType = {
    p1012: {},
  };

  public async confirmButton(props?: any) {
    const withdrawConfigItem = this.withdrawConfig[environment.product]?.[this.selectedWithdrawItem.Description];
    if (withdrawConfigItem) {
      this.withdrawPaymentAction(withdrawConfigItem, props).then();
    }
  }

  public async withdrawPaymentAction(configItem: withdrawConfigItemType, props: any) {
    this._UiHelper.setLoadingDialog(true);

    try {
      const actionResult: paymentResultType = await configItem.paymentMethod(props);
      const result = configItem.resultType(actionResult, configItem);
      this.selectedWithdrawItem.result = result;
      if (result.success === true) {
        setTimeout(() => {
          this._UiHelper.withdrawCardDimmer = false;
          this.amount = '';
          this.selectedWithdrawItem = {
            MaxValue: null,
            MinValue: null,
            Description: '',
            DepositTypeId: null,
            paymentMethodId: '',
            result: {
              finished: false,
              success: false,
              message: '',
            },
          };
          const bodyElement = document.body;
          bodyElement.classList.remove('no-scroll-deposit-withdraw');
        }, 4000);
      }
      this._ApiService.getClient2().then().catch();
    } catch (e) {
      // todo error kodlar değişmeli
      this.selectedWithdrawItem.result = {
        success: false,
        message: this._TranslateService.instant('errorcode14'),
        finished: true,
      };
    }
    this._UiHelper.setLoadingDialog(false);
  }

  public paymentResult4(paymentResult: any) {
    if (paymentResult.code === 'success') {
      this._UiHelper.successSnackBar(this._TranslateService.instant(paymentResult.message), '');
      return { success: true, message: this._TranslateService.instant(paymentResult.message), finished: true };
    } else if (paymentResult.code === 'error') {
      this._UiHelper.errorSnackBar(this._TranslateService.instant('errorcode14'), '');
      return { success: false, message: this._TranslateService.instant('errorcode14'), finished: true };
    } else if (paymentResult.code === 'errorcode') {
      this._UiHelper.errorSnackBar(this._TranslateService.instant(paymentResult.description), '');
      return { success: false, message: paymentResult.description, finished: true };
    }
  }

  /**
   * IXOPAY payment result
   * This function processes the result of a payment transaction
   * It parses the payment result, checks its status, displays a snack bar message
   * based on the status and returns an object with success status, message and a finished flag
   *
   * @param {string} paymentResult - The JSON string of payment result. It needs to be parsed to an object
   *
   * @returns {Object} - Returns an object that contains:
   * success : a boolean that represents if the payment is successful,
   * message : a string that represents the detailed status message, and
   * finished : a boolean that represents if the payment process is finished.
   */
  public paymentResult1(paymentResult: string | any) {
    let paymentJsonResult: paymentResultType;

    try {
      paymentJsonResult = JSON.parse(paymentResult);
    } catch (e) {
      paymentJsonResult = paymentResult;
    }
    if (paymentJsonResult.result === 'success') {
      return { success: true, message: this._TranslateService.instant('WITHDRAW.GENERAL.SUCCESS'), finished: true };
    } else if (paymentJsonResult.result === 'error') {
      this._UiHelper.errorSnackBar(this._TranslateService.instant('WITHDRAW.GENERIC.ERROR'), '');
      return { success: false, message: this._TranslateService.instant('WITHDRAW.GENERIC.ERROR'), finished: true };
    } else if (paymentJsonResult.result === 'errorcode') {
      this._UiHelper.errorSnackBar(this._TranslateService.instant(paymentJsonResult.desc), '');
      return { success: false, message: paymentJsonResult.desc, finished: true };
    }
  }
  public paymentResult2(paymentResult: string) {
    const paymentJsonResult: paymentResultPay3000Type = JSON.parse(paymentResult);
    if (paymentJsonResult.Status === 'true') {
      const info_message = this._TranslateService.instant('arenaPayInfoMessage');
      this._UiHelper.successSnackBar(info_message, '');
      return { success: true, message: '', finished: true };
    } else {
      let errorMessage: any = paymentJsonResult.ErrorMessage;
      try {
        errorMessage = JSON.parse(errorMessage);
        return { success: false, message: errorMessage?.error, finished: true };
      } catch (e) {
        return { success: false, message: paymentJsonResult.ErrorMessage, finished: true };
      }
    }
  }

  public paymentResult3(paymentResult: string) {
    const paymentJsonResult: paymentResultType = JSON.parse(paymentResult);
    if (paymentJsonResult.result === 'success') {
      this._UiHelper.successSnackBar(paymentJsonResult.desc, '');
      return { success: true, message: paymentJsonResult.desc, finished: true };
    } else if (paymentJsonResult.result === 'error') {
      this._UiHelper.errorSnackBar(this._TranslateService.instant('WITHDRAW.GENERIC.ERROR'), '');
      return { success: false, message: this._TranslateService.instant('WITHDRAW.GENERIC.ERROR'), finished: true };
    } else if (paymentJsonResult.result === 'errorcode') {
      this._UiHelper.errorSnackBar(this._TranslateService.instant(paymentJsonResult.desc), '');
      return { success: false, message: paymentJsonResult.desc, finished: true };
    }
  }

  public getWithdrawPaymentList() {
    this._ApiService.getAllWithdrawControl().then(result => {
      if (result.length > 0) {
        this.withdrawPaymentList = result;
        this._UserHelper.withdrawList = result;
      }
    });
  }

  private updateUserData() {
    this._ApiService
      .getClient()
      .then(result => {
        this._UserHelper.setUser(result);
      })
      .catch();
  }
}
